"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var RotatingContainer = (
/*#__PURE__*/
0, _styledBase.default)('div', {
  target: "e1fhen290"
})(function (_ref) {
  var isRotated = _ref.isRotated;
  return {
    transition: 'transform 0.2s',
    transform: isRotated ? 'rotate(180deg)' : 'rotate(0)'
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zdWJtb2R1bGVzL2hlbHBlcnMvUm90YXRpbmdDb250YWluZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU0wQiIsImZpbGUiOiIuLi8uLi8uLi9zcmMvc3VibW9kdWxlcy9oZWxwZXJzL1JvdGF0aW5nQ29udGFpbmVyLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuaW50ZXJmYWNlIFJvdGF0aW5nQ29udGFpbmVyUHJvcHMge1xuICBpc1JvdGF0ZWQ6IGJvb2xlYW47XG59XG5cbmNvbnN0IFJvdGF0aW5nQ29udGFpbmVyID0gc3R5bGVkKCdkaXYnKTxSb3RhdGluZ0NvbnRhaW5lclByb3BzPihcbiAgKHsgaXNSb3RhdGVkIH0pID0+ICh7XG4gICAgdHJhbnNpdGlvbjogJ3RyYW5zZm9ybSAwLjJzJyxcbiAgICB0cmFuc2Zvcm06IGlzUm90YXRlZCA/ICdyb3RhdGUoMTgwZGVnKScgOiAncm90YXRlKDApJ1xuICB9KVxuKTtcblxuUm90YXRpbmdDb250YWluZXIuZGlzcGxheU5hbWUgPSAnUm90YXRpbmdDb250YWluZXInO1xuXG5leHBvcnQgZGVmYXVsdCBSb3RhdGluZ0NvbnRhaW5lcjtcbiJdfQ== */");
RotatingContainer.displayName = 'RotatingContainer';
var _default = RotatingContainer;
exports.default = _default;